import { z } from 'zod';
import { BandScoreSchema } from './sessions.js';
export const LeaderboardRowSchema = z.object({
    rank: z.number().int().positive(),
    userId: z.string().uuid(),
    displayName: z.string(),
    /** Public profile photo URL from Telegram (HTTPS); null if unset. */
    photoUrl: z.string().nullable(),
    avgBand: BandScoreSchema,
    sessionsScored: z.number().int().nonnegative(),
});
export const LeaderboardMeSchema = z.object({
    rank: z.number().int().positive().nullable(),
    avgBand: BandScoreSchema.nullable(),
    sessionsScored: z.number().int().nonnegative(),
});
export const LeaderboardResponseSchema = z.object({
    rows: z.array(LeaderboardRowSchema),
    me: LeaderboardMeSchema,
});
